import React from 'react';

import image from '../../img/no_image.jpg';

const NoImagePlaceHolder = () => <img src={image} alt="" />;

export default NoImagePlaceHolder;
